import { useParams } from "react-router-dom";
import { BreadcrumbChild } from "../../../../components/BreadcrumbCustom/BreadcrumbCustom";
import { StyledIcon } from "../../../../components/StyledIcon/StyledIcon";
import { routesConfig } from "../../../../config/routes";
import { CreateScheduleForm } from "../../shared/CreateScheduleForm";

const CreateScheduling: React.FC = () => {
  const { id } = useParams();
  const isEditing = Boolean(id);
  const breadcrumbs: BreadcrumbChild[] = [
    { isIcon: true, icon: <StyledIcon iconType="home" /> },
    {
      label: "Descargas",
      link: routesConfig.STORAGE().RIVER_DISCHARGES,
    },
    {
      label: `${isEditing ? "Editar" : "Novo"} pedido de descarga`,
    },
  ];
  return <CreateScheduleForm breadcrumbs={breadcrumbs} />;
};

export default CreateScheduling;
